var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTable",
    {
      staticClass: "activities-listing-table--loading",
      attrs: { border: _vm.border, size: "large" }
    },
    [
      _c(
        "CompassTableHead",
        _vm._l(_vm.colsHeader, function(column, index) {
          return _c(
            "CompassTableHeadCell",
            { key: index, attrs: { width: column.width } },
            [
              _c("CompassSkeleton", {
                attrs: {
                  variant: column.skeleton.variant,
                  size: column.skeleton.size
                }
              })
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "CompassTableBody",
        _vm._l(24, function(_, indexRow) {
          return _c(
            "CompassTableRow",
            { key: indexRow },
            _vm._l(_vm.colsBody, function(column, indexCol) {
              return _c(
                "CompassTableBodyCell",
                { key: indexCol },
                [
                  _c("CompassSkeleton", {
                    attrs: {
                      variant: column.skeleton.variant,
                      size: column.skeleton.size
                    }
                  })
                ],
                1
              )
            }),
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }